var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("退单详情"),
      visible: _vm.visible,
      footer: null,
      width: 820
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.orderNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "orderNo", $$v);
      },
      expression: "dataFrom.orderNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保单号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "policyNo", $$v);
      },
      expression: "dataFrom.policyNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单金额")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.orderAmount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "orderAmount", $$v);
      },
      expression: "dataFrom.orderAmount"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保数量")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.servings,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "servings", $$v);
      },
      expression: "dataFrom.servings"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("退单人员")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.insuredName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "insuredName", $$v);
      },
      expression: "dataFrom.insuredName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("退款金额")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.refundTotalAmount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "refundTotalAmount", $$v);
      },
      expression: "dataFrom.refundTotalAmount"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("退款流水号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.payNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "payNo", $$v);
      },
      expression: "dataFrom.payNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("申请人")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.nickName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "nickName", $$v);
      },
      expression: "dataFrom.nickName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("退款时间")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.createAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "createAt", $$v);
      },
      expression: "dataFrom.createAt"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };